import $http from '$http'
import {
    lg,
    util
} from 'utils';
import {
    GetERP_OrderById
} from '@api/orderApi.js';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig,
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';

export default {
    methods: {
        //VoucherType:2  调用   OrderAuditForFinanceEx , VoucherType:3  调用  OrderAuditForFinance3 , VoucherType:1 ContractMoneyConfirm 合同款审核
        // VoucherType:2 3 调用   OrderAuditForFinanceEx 2018/1/4修改
        //OrderAuditByFinance
        auditConfirm2(params) {
            $http.post('api/Order/OrderAuditByFinance', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '审核成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('reLoadData');
                });
            });
        },
        // 会销下单审核 VoucherType:3 
        // auditConfirm3(params) {
        //     $http.post('api/Order/OrderAuditForFinance3', params).then(res => {
        //         util.doResult(this, res, () => {
        //             this.$notify({
        //                 title: '成功',
        //                 message: '审核成功！',
        //                 type: 'success'
        //             });
        //             this.dialogVisible = false;
        //             this.$emit('reLoadData');
        //         });
        //     });
        // },
        getInfo(options) {
            let opts = $.extend({}, this.getErpConfig(), options);
            let param = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: opts.id
            };
            GetERP_OrderById(param).then(res => {
                util.doResult(this, res, () => {
                    this.OrderData = res.data.Data;
                    this.auditFormData.OrderId = this.OrderData.OrderId;
                    this.auditFormData.TimeStamp = this.OrderData.TimeStamp
                    if (this.OrderData.OrderStatus !== 6 && this.OrderData.OrderStatus !== 11) {
                        this.auditFormData.OrderStatus = null
                    } else {
                        this.auditFormData.OrderStatus = this.OrderData.OrderStatus;
                    }

                    this.auditFormData.Bank = this.OrderData.Bank;
                    this.auditFormData.AuditRemark = this.OrderData.AuditRemark;
                    this.auditFormData.VoucherMoney = this.OrderData.VoucherMoney; //凭证金额
                    if (this.OrderData.PreReceiveCode == '--') {
                        this.auditFormData.PreReceiveCode = '' //预收单
                    } else {
                        this.auditFormData.PreReceiveCode = this.OrderData.PreReceiveCode; //预收单
                    }

                    if (this.auditFormData.OrderStatus == 6) {
                        this.isAuditRemark = false;
                        this.VoucherMoney = true
                    } else if (this.auditFormData.OrderStatus == 11 || this.auditFormData.OrderStatus == 12) {
                        this.isAuditRemark = true;
                        this.VoucherMoney = false
                    } else {
                        this.isAuditRemark = false;
                        this.VoucherMoney = false
                    }

                    if (this.OrderData.SendGoods.length > 0) {
                        this.IsShow = true;
                    } else {
                        this.IsShow = false;
                    }
                    if (this.auditFormData.OrderStatus == 1) {
                        this.auditFormData = this.getAuditFormData()
                        this.auditFormData = ''
                    }
                    //会销
                    for (let i = 0; i < this.OrderData.PayList.length; i++) {
                        if (this.OrderData.PayList[i].VoucherPic !== '') {
                            this.OrderData.PayList[i].changePic = []
                            let picArr = this.OrderData.PayList[i].VoucherPic.split(',');
                            for (let j = 0; j < picArr.length; j++) {
                                this.OrderData.PayList[i].changePic.push({
                                    "Url": picArr[j]
                                });
                            }
                        } else {
                            this.OrderData.PayList[i].changePic = []
                        }
                    }


                });
            });
        },
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
    },
};


// WEBPACK FOOTER //
// ./src/pages/Order/voucherAudit/components/voucherAuditDialog/services.js